import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Subscription} from "rxjs";
import { GadgetApiService, PageNotificationService, GadgetsService } from '@signature-it/ngx-generic/services';
import { RestUrlsConfig, GenericConfig } from '@signature-it/ngx-generic/config';
import {GadgetFilterDTO} from '@signature-it/ngx-generic/models';

declare let _: any;

@Component({
    selector: 'list-by-filters-gadget',
    templateUrl: './list-by-filters.gadget.html',
    styleUrls: ['./list-by-filters.gadget.scss'],
    standalone: false
})
export class ListByFiltersGadget implements OnInit{
    @Input() data: Array<any>;
    @Input() dataCount: number;
    @Input() title: string;
    @Input() url: string;
    @Input() type: string;
    @Input() key: string;
    @Input() dataConfig: string;
    @Input() filterName: string;
    @Input() labels: Array <string>;
    @Input() link: boolean = false;
    qtyFilters;
    filters;
    serverSideFilter;
    gadgetFilterSubscription: Subscription;
    open = false;
    loader: boolean = false;
    print: boolean = false;

    constructor(protected gadgetApiSvc: GadgetApiService,
                protected gadgetSvc: GadgetsService) {}

    ngOnInit() {
        this.type = this.type || 'ListByFiltersGadget';
        this.key = this.key || 'list-by-filters-gadget';
        this.filterName = this.filterName || 'ListByFilters';
        let gadgetConfig = GenericConfig.gadgets.find(x => x.type === this.type && x.key === this.key);
        if (gadgetConfig) {
            this.url = this.url || gadgetConfig.url;
            this.title = this.title || gadgetConfig.title;
            this.dataConfig = this.dataConfig || gadgetConfig.data;
            this.labels = this.labels || gadgetConfig.labels;
        }
        this.qtyFilters = GenericConfig.filterGadget.filter(x => x.name === this.filterName && x.serverSide ).length;
        this.setFilters();
    }


    setFilters() {

        this.gadgetFilterSubscription = this.gadgetSvc.gadgetFilter.subscribe(gadgetFilter => {
            let serverSideFilter = _.filter(gadgetFilter, (filter: any) => filter.name === this.filterName && filter.serverSide);
            if (serverSideFilter) {
                if (!this.serverSideFilter || this.gadgetSvc.compareVal(serverSideFilter, this.serverSideFilter)) {
                    this.serverSideFilter = [];
                    serverSideFilter.forEach(dataFilter => {
                        this.serverSideFilter.push(new GadgetFilterDTO(dataFilter))
                    });
                    if (this.gadgetSvc.hasParams(this.serverSideFilter) && this.serverSideFilter.length == this.qtyFilters) {
                        this.getData();
                    }
                }
                let filters = _.find(gadgetFilter, (filter: any) => filter.name === this.filterName && !filter.serverSide);
                if (filters != this.filters) {
                    this.filters = _.cloneDeep(filters);
                }
            }
        });
    }

    getData() {
        this.loader = true;
        this.dataCount = 0;
        let params = this.gadgetSvc.setParams(this.serverSideFilter, this.dataConfig);
        this.gadgetApiSvc.getGadgetData(params , this.url)
            .subscribe(res => {
                this.loader = false;
                this.data = _.chain(res)
                    .groupBy( data => data[0])
                    .value();
                _.forEach(this.data, (group) => {
                    let sum = _.sumBy(group, (v) => parseInt(v[2]));
                    _.forEach(group, (val) => {
                        val[1] = decodeURI(val[1]);
                        val.push(val[2] * 100 / sum);
                    });
                });
            });
    }

    onPrintNotify() {
        this.print = !this.print;
    }

}
